export default __webpack_public_path__ + "static/media/KILLABYTEZ.1ffc5d1b.png";